import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Link, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Home } from "lucide-react";
import { BudgetProvider } from "./context/BudgetContext";
import { I18nProvider } from "./context/I18nContext";
import { Sidebar, MobileNav } from "./components/Sidebar";
import { ClientModule } from "./modules/ClientModule";
import { RevenusModule } from "./modules/RevenusModule";
import { DepensesModule } from "./modules/DepensesModule";
import { AnalyseModule } from "./modules/AnalyseModule";
import { OptimisationModule } from "./modules/OptimisationModule";
import { RecommandationsModule } from "./modules/RecommandationsModule";
import Landing from "./pages/Landing";

const MODULES = {
  client: ClientModule,
  revenus: RevenusModule,
  depenses: DepensesModule,
  analyse: AnalyseModule,
  optimisation: OptimisationModule,
  recommandations: RecommandationsModule,
};

function BackHomeButton() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/")}
      data-testid="btn-back-home"
      className="hidden md:flex fixed top-4 right-4 z-40 items-center gap-1.5 bg-white/80 backdrop-blur-xl border border-slate-200 text-indigo-950 rounded-xl px-3 py-2 text-sm font-medium transition-all hover:bg-white shadow-sm"
      aria-label="Back to home"
    >
      <Home className="w-4 h-4" />
      <span className="hidden sm:inline">Accueil</span>
    </button>
  );
}

function Shell() {
  const [active, setActive] = useState("client");
  const Active = MODULES[active];

  return (
    <div className="min-h-screen bg-slate-50 relative overflow-x-hidden">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          backgroundImage:
            "radial-gradient(60% 40% at 10% 0%, rgba(99,102,241,0.12), transparent 70%), radial-gradient(50% 35% at 95% 20%, rgba(16,185,129,0.10), transparent 70%), radial-gradient(45% 30% at 80% 100%, rgba(251,191,36,0.10), transparent 70%)",
        }}
      />
      <Sidebar active={active} onChange={setActive} />
      <MobileNav active={active} onChange={setActive} />
      <BackHomeButton />
      <main className="md:ml-64 min-h-screen pb-24 md:pb-0">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-6 md:py-16">
          <div key={active} className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            <Active />
          </div>
          <footer className="mt-16 pt-8 border-t border-slate-200/70 text-xs text-slate-400 flex flex-wrap gap-2 justify-between">
            <span>
              <Link to="/" className="hover:text-indigo-950 transition-colors">BudgetLens</Link> © {new Date().getFullYear()}
            </span>
          </footer>
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <BudgetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/app" element={<Shell />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </BudgetProvider>
    </I18nProvider>
  );
}

export default App;
